export function formatISO8601toBRDate(iso8601Date: string) {
  const [year, month, day] = iso8601Date.split('T')[0].split('-');

  if (!day || !month || !year) {
    return '';
  }

  const brDate = `${day}/${month}/${year}`;

  return brDate;
}
